<template>
  <div class="focus:outline-none outline-none text-sm">
    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
      <div class="flex items-center py-2 bg-gray-600 px-2 rounded-t-lg">
        <button
          class="focus:outline-none text-gray-100 py-1 text-center"
          :class="{ 'bg-gray-700': isActive.bold() }"
          @click="commands.bold"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="h-5 w-5 flex-shrink-0 mr-1.5"
          >
            <path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z" />
            <path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z" />
          </svg>
        </button>

        <button
          class="focus:outline-none text-gray-100 py-1 text-center l"
          :class="{ 'bg-gray-700': isActive.italic() }"
          @click="commands.italic"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="h-5 w-5 flex-shrink-0 mr-1.5"
          >
            <line x1="19" y1="4" x2="10" y2="4" />
            <line x1="14" y1="20" x2="5" y2="20" />
            <line x1="15" y1="4" x2="9" y2="20" />
          </svg>
        </button>

        <button
          class="focus:outline-none text-gray-100 py-1 text-center l"
          :class="{ 'bg-gray-700': isActive.underline() }"
          @click="commands.underline"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="h-5 w-5 flex-shrink-0 mr-1.5"
          >
            <path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3" />
            <line x1="4" y1="21" x2="20" y2="21" />
          </svg>
        </button>

        <button
          class="focus:outline-none text-gray-100 py-1 text-center"
          :class="{ 'bg-gray-700': isActive.heading({ level: 1 }) }"
          @click="commands.heading({ level: 1 })"
        >
          <span class="h-5 w-5 flex-shrink-0 mr-1.5">H1</span>
        </button>

        <button
          class="focus:outline-none text-gray-100 py-1 text-center"
          :class="{ 'bg-gray-700': isActive.heading({ level: 2 }) }"
          @click="commands.heading({ level: 2 })"
        >
          <span class="h-5 w-5 flex-shrink-0 mr-1.5">H2</span>
        </button>

        <button
          class="focus:outline-none text-gray-100 py-1 text-center"
          :class="{ 'bg-gray-700': isActive.heading({ level: 3 }) }"
          @click="commands.heading({ level: 3 })"
        >
          <span class="flex-shrink-0 mr-1.5">H3</span>
        </button>

        <button
          class="focus:outline-none text-gray-100 py-1 text-center"
          :class="{ 'bg-gray-700': isActive.bullet_list() }"
          @click="commands.bullet_list"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="h-5 w-5 flex-shrink-0 mr-1.5"
          >
            <line x1="8" y1="6" x2="21" y2="6" />
            <line x1="8" y1="12" x2="21" y2="12" />
            <line x1="8" y1="18" x2="21" y2="18" />
            <line x1="3" y1="6" x2="3.01" y2="6" />
            <line x1="3" y1="12" x2="3.01" y2="12" />
            <line x1="3" y1="18" x2="3.01" y2="18" />
          </svg>
        </button>
      </div>
    </editor-menu-bar>

    <editor-content
      class="bg-gray-600 text-white focus:outline-none py-2 px-3 max-h-64 overflow-hidden text-sm border-gray-700 rounded-b-lg border-t"
      :editor="editor"
    />
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import {
  Heading,
  BulletList,
  ListItem,
  Bold,
  Italic,
  Underline,
  History,
} from "tiptap-extensions";

export default {
  components: {
    EditorMenuBar,
    EditorContent,
  },
  props: {
    newSetData: { default: "" },
  },
  data() {
    return {
      defaultData: `<p></p><p></p>`,
      editor: new Editor({
        onUpdate: ({ getHTML }) => {
          this.$emit("input", getHTML());
        },
        extensions: [
          new Heading({ levels: [1, 2, 3] }),
          new BulletList(),
          new ListItem(),
          new Bold(),
          new Italic(),
          new Underline(),
          new History(),
        ],
        content: ``,
      }),
    };
  },
  watch: {
    newSetData: function () {
      if (this.newSetData != "") this.editor.setContent(this.newSetData);
      else this.editor.setContent(``);
    },
  },
  mounted() {
    //console.log("editor mounted");
    if (this.newSetData != "") this.editor.setContent(this.newSetData);
    else this.editor.setContent(``);
  },
  beforeDestroy() {
    this.editor.destroy();
  },
};
</script>
<style lang="postcss" >
/* purgecss start ignore */
.ProseMirror-focused {
  @apply outline-none;
}
/* purgecss end ignore */
</style>